import React from "react";
import styled from "styled-components";

interface AlertModalProps {
  setError: (value: boolean) => void;
  errorMessage: string;
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 32px;
  width: 90%;
  max-width: 600px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2);
  text-align: center;
  position: relative;
  transform: scale(0.8);
  animation: popIn 0.3s ease-out forwards;

  @keyframes popIn {
    from {
      transform: scale(0.8);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const ModalHeader = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #0173c6;
  text-transform: uppercase;
`;

const ModalMessage = styled.p`
  font-size: 16px;
  color: #444444;
  margin-bottom: 24px;
  line-height: 1.5;
`;

const ModalButton = styled.button`
  background: #0173c6;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  width: 100px;

  &:hover {
    background-color: #005b9e;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const CloseIcon = styled.span`
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #aaaaaa;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #666666;
  }
`;

const AlertModal: React.FC<AlertModalProps> = ({ setError, errorMessage }) => {
  return (
    <ModalOverlay>
      <ModalContent>
        <CloseIcon onClick={() => setError(false)}>×</CloseIcon>
        <ModalHeader>Alert</ModalHeader>
        <ModalMessage>{errorMessage}</ModalMessage>
        <ModalButton onClick={() => setError(false)}>OK</ModalButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default AlertModal;
